import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import OperationService from '../../../../services/OperationService/OperationService';
import AllProcesses from './AllProcesses';
/**
 * @Description This function lets you return Dashboard component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ActivityCenter() {
    const { t } = useTranslation();
    const label = 'CONTENT.DASHBOARD.';

    // Initial state
    const [state, setState] = useState([]);
    const [open, setOpen] = useState(false);
    // Fetch data on start
    useEffect(() => { fetchData(); }, []);
    // Fetch Activity Center data
    const fetchData = async () => {
        const res = await OperationService.getOperation('', '', 'automation');
        // Update state value
        if (res?.status) { setState(res.data); }
    }
    // Handle View All Processes
    const handleClick = () => { setOpen(!open); }
    return (
        <div className="db-page" style={{padding: 0}}>
            <div style={{fontWeight: 'bold', borderBottom: '2px solid #f6f6f6', padding: '5%'}}>
                <div style={{fontWeight: 'bold'}}>{t(label+'ACTIVITY-CENTER')}</div>
                <div style={{color: '#b6b6b6'}}>{t(label+'AUTOMATION-BOTS')}</div>
            </div>
            <table style={{fontWeight: 'bold', borderBottom: '2px solid #f6f6f6', padding: '5%'}}>
                <tbody>
                    <tr className="db-tr">
                        <th className="db-seclabel">{t(label+'BOT')}</th>
                        <th className="db-seclabel" style={{textAlign: 'end'}}>{t(label+'LAST-ACTIVITY')}</th>
                    </tr>
                    {state.map((item, itemI) => {
                        return (
                            <tr className="db-tr" key={itemI}>
                                <td className="db-td1">
                                    <div>{item.name}</div>
                                    <div className="db-seclabel">{item.timeElapsed + ' min'}</div>
                                </td>
                                <td className="db-td3"><span className="db-seclabel">{item.complatedAt}</span></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="view-all-process">
                <Button onClick={handleClick}>{t(label+'VIEW-ALL-PROCESS')}</Button>
            </div>
            {open && <AllProcesses setOpen={setOpen}/>}
        </div>
    );
}
export default ActivityCenter;